"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canonicalStringify = canonicalStringify;
/** JSON with object keys sorted at every depth: the byte form that local
 * authority signatures and release digests are computed over. */
function canonicalStringify(value) {
    if (value === null || typeof value !== 'object') {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return `[${value.map(canonicalStringify).join(',')}]`;
    }
    const record = value;
    return `{${Object.keys(record)
        .sort()
        .map(key => `${JSON.stringify(key)}:${canonicalStringify(record[key])}`)
        .join(',')}}`;
}
